module.exports = __webpack_public_path__ + "static/digital_team-90c4c4401aeb8da50c4ef8478ab4c8da.png";